import React from 'react';
import UserTable from '../components/UserTable';

function UsersPage() {
  return <UserTable />;
}

export default UsersPage;